import { useNavigate } from '@tanstack/react-router'
import { ArrowRight } from 'lucide-react'
import { AgentCanvasPreview } from '@/features/agents-marketing/components/AgentCanvasPreview'
import { useBuildTeamCta } from '@/features/agents-marketing/hooks/useBuildTeamCta'
import { PageHero } from '@/shared/components/marketing/PageHero'
import { Button } from '@/components/ui/button'

export function AgentsHero() {
  const navigate = useNavigate()
  const build = useBuildTeamCta()

  return (
    <PageHero
      eyebrow="Agent teams"
      title="One model id."
      accent="A whole team."
      lede="A coordinator model, the specialists it can call, and your choice of who writes the reply. Called like any model."
      aside={<AgentCanvasPreview />}
    >
      <div className="flex flex-wrap gap-3">
        <Button
          onClick={() => navigate({ to: build.to })}
          size="lg"
          className="font-semibold"
        >
          {build.label}
          <ArrowRight />
        </Button>
        <Button
          onClick={() =>
            navigate({
              to: '/docs/$',
              params: { _splat: 'dashboard/agents' },
            })
          }
          variant="outline"
          size="lg"
          className="font-semibold"
        >
          Read the docs
        </Button>
      </div>
    </PageHero>
  )
}
